import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import Styles from '../../../../Styles';
import {
  FlatList,
  Platform,
  RefreshControl,
  StyleProp,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import FontAwesome5Pro from 'src/components/icons/FontAwesomeIcon';
import Localized from 'src/constants/AppStrings';
import React from 'react';
import AVText from 'src/components/elements/AVText';
import CreditCard from 'src/models/CreditCard';
import {WithLocalizedProps} from 'src/types/PropTypes';
import CreditCardImage from 'src/components/elements/CreditCardImage';
import Star from 'src/components/img/svg/inbox/Star';
import Settings from 'src/Settings';
import AccountConstants from 'src/constants/AccountConstants';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import AccountStore from 'src/stores/AccountStore';
import {getDescriber} from '../../../../../components/elements/descriptor/DescriptorType';
import EmptyCards from 'src/components/img/svg/cards/emptyCards';
import Util, {capitalizeFirstWord} from 'src/Util';
import {getToastDescriber} from 'src/components/elements/toastDescriptor/DescroiptorType';
export function getWalletTopButtonsSection(callbacks): JSX.Element {
  const marketCard = AccountStore.getMarketCard();
  const marketCardLabel = marketCard
    ? Localized.Labels.edit_market_card
    : Localized.Labels.add_market_card;
  return null;
}
function getRoundedAppButton(label, hint, onPress, isLastItem?: boolean) {
  return (
    <RoundedAppButton
      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm0}
      accessibilityLabelValue={label}
      accessibilityHintValue={hint}
      aria-label={label}
      buttonViewStyle={[
        {
          borderWidth: 1,
          backgroundColor: Styles.white,
          //height: 40,
          paddingHorizontal: 20,
          paddingVertical: 12,
        },
      ]}
      buttonContainerStyle={[
        getWalletStyles()['addBtn'],
        isLastItem ? {marginRight: 25} : null,
      ]}
      textStyle={{
        fontWeight: Platform.OS === 'android' ? 'bold' : '700',
        fontFamily: getToastDescriber().snackBarFontFamily(),
        fontSize:
          Settings.buildType === 'canteen'
            ? Styles.Fonts.f1
            : Styles.Fonts.f1 - 2,
        color: Styles.black,
      }}
      buttonType={RoundedAppButtonType.Outline}
      titleText={label}
      onPress={onPress}
    />
  );
}

function getListCardsTitle(): JSX.Element {
  return (
    <AVText
      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm0}
      style={getDescriber().walletScreenCardStyles()['balancesTitle']}
    >
      {Localized.Labels.cards_wallet}
    </AVText>
  );
}
function getListTitle(): JSX.Element {
  return getListCardsTitle();
}
function getCardsEmptyList() {
  return (
    <View style={getWalletStyles()['noCardsOrBalancesImage']}>
      <EmptyCards size={100}></EmptyCards>
      <AVText
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
        style={[getWalletStyles()['noCardsOrBalances'], {marginTop: 0}]}
      >
        {Localized.Labels.no_cards_added}
      </AVText>
    </View>
  );
}
function showListOrEmpty(state, callback, listItem) {
  if (listItem.length > 0) {
    return (
      <View>
        <FlatList
          data={listItem}
          renderItem={({item}) => (
            <CreditCardCell
              key={item.id}
              strings={Localized}
              creditCard={item}
              onCreditCardClick={callback}
            />
          )}
          automaticallyAdjustContentInsets={true}
          extraData={state}
          keyExtractor={(item) => item.id}
          contentContainerStyle={{
            paddingHorizontal: Settings.isNewUI() ? Styles.Spacing.m3 : 0,
          }}
        />
      </View>
    );
  } else {
    if (!state.showPayroll) return getCardsEmptyList();
  }
}
function getSection(state, callback, listItem) {
  return (
    <View>
      {getListTitle()}
      {showListOrEmpty(state, callback, listItem)}
    </View>
  );
}
export function getWalletCreditCardsSection(
  props,
  state,
  callbacks,
  onRefresh,
): JSX.Element {
  return (
    <View style={{flex: 1}}>
      <FlatList
        data={[props.creditCards]}
        renderItem={({item}) => getSection(state, callbacks[0], item)}
        automaticallyAdjustContentInsets={false}
        ListFooterComponent={() => renderPayroll(props, state, callbacks[1])}
        extraData={state}
        keyExtractor={(item) => item}
        contentContainerStyle={{
          paddingHorizontal: Settings.isNewUI() ? Styles.Spacing.m3 : 0,
        }}
        refreshControl={
          <RefreshControl
            refreshing={state.isRefreshing}
            onRefresh={onRefresh}
            tintColor={Styles.primaryColor}
            colors={[Styles.primaryColor]}
            titleColor={Styles.black}
          />
        }
      />
    </View>
  );
}
function getAmexExtraSVGPadding(issuer): StyleProp<ViewStyle> {
  switch (issuer.toLowerCase()) {
    case 'american-express':
    case 'american express':
    case 'americanexpress':
    case 'amex':
      return getWalletStyles()['amexSVGPadding'];
  }

  return null;
}

function getWidthAndHeightCombination(creditCardType: string): {
  [index: string]: {[index: string]: number | string};
} {
  switch (creditCardType.toLowerCase()) {
    case 'visa':
      return {size: {width: 30, height: 20}};
    case 'dinersclub':
      return {size: {width: 30, height: 20}};
    case 'jcb':
      return {size: {width: 30, height: 20}};
    case 'american-express':
    case 'american express':
    case 'americanexpress':
    case 'amex':
      return {size: {width: 35, height: 35}};

    case 'discover':
      return {size: {width: 30, height: 20}};

    case 'master-card':
    case 'mastercard':
      return {size: {width: 30, height: 20}};

    case AccountConstants.APPLE_PAY_TOKEN:
      return {size: {width: 30, height: 20}};

    case AccountConstants.GOOGLE_PAY_TOKEN:
      return {size: {width: 30, height: 20}};

    case AccountConstants.PAYROLL_TOKEN:
      return {size: {width: 35, height: 35}};
    case AccountConstants.PAYROLL_TOKEN_REDESIGN:
      return {size: {width: 30, height: 20}};
    case AccountConstants.PAYROLL_TOKEN_COMPANY:
      return {size: {width: 30, height: 20}};
  }
}

type CreditCardCellProps = WithLocalizedProps & {
  onCreditCardClick: (creditCard) => void;
  creditCard: CreditCard;
};
function getCardExpiredLayout(creditCard): JSX.Element {
  if (Util.isCreditCardExpired(creditCard)) {
    return (
      <View
        style={{
          borderRadius: 4,
          paddingHorizontal: 12,
          paddingVertical: 4,
          backgroundColor: '#F5DFE2',
        }}
      >
        <AVText
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
          style={{
            fontSize: Styles.Fonts.f8,
            fontFamily: getDescriber().walletForntStyleText(),
            color: Styles.dangerColor,
          }}
        >
          {Localized.Labels.wallet_card_expired}
        </AVText>
      </View>
    );
  } else {
    return null;
  }
}
function getCreditCardNumber(ccNumber: string) {
  return 'x' + ccNumber?.slice(-4);
}
const CreditCardCell: React.FC<CreditCardCellProps> = ({
  onCreditCardClick,
  creditCard,
  strings,
}) => (
  // <AVTouchableOpacity
  //   accessible={true}
  //   accessibilityRole="button"
  //   accessibilityHint="Double tap to navigate to the screen of the chosen card to update info or delete"
  //   role="button"
  //   onPress={() => onCreditCardClick(creditCard)}
  //   accessibilityLabel="onCreditCardClick"
  //   aria-label="onCreditCardClick"
  // >
  //   <View style={[getWalletStyles()['creditCard']]}>
  //     <View style={[getWalletStyles()['creditCardInfo']]}>
  //       <View
  //         accessibilityLabel={`Issuer ${creditCard.cardIssuer}`}
  //         accessibilityRole="image"
  //         aria-label={`Issuer ${creditCard.cardIssuer}`}
  //         role="img"
  //         style={[]}
  //       >
  //         <CreditCardImage issuer={creditCard.cardIssuer} />
  //       </View>
  //       <View style={{padding: Styles.Spacing.m2 + 4}}>
  //         <AVText
  //           maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
  //           accessibilityLabel={strings.Labels.credit_card}
  //           accessibilityRole="text"
  //           aria-label={`${strings.Labels.credit_card}, text`}
  //           style={[getWalletStyles()['label']]}
  //         >
  //           {strings.Labels.credit_card}
  //         </AVText>
  //         <AVText
  //           maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
  //           accessibilityLabel={creditCard.name}
  //           accessibilityRole="text"
  //           aria-label={`${creditCard.name}, text`}
  //           style={[getWalletStyles()['cardNumber']]}
  //         >
  //           {creditCard.name}
  //         </AVText>
  //       </View>
  //     </View>
  //     {creditCard.isDefault && (
  //       <View style={[getWalletStyles()['starIconView'], {left: 25}]}>
  //         <View
  //           accessibilityLabel="Default payment method, "
  //           aria-label="Default payment method, "
  //           style={getWalletStyles()['starIcon']}
  //         >
  //           <Star width={Styles.Fonts.f3} height={Styles.Fonts.f3} />
  //         </View>
  //       </View>
  //     )}
  //     <View
  //       style={[
  //         getWalletStyles()['starIconView'],
  //         //creditCard.isDefault ? {left: 20} : {left: 40},
  //       ]}
  //     >
  //       {
  //         <FontAwesome5Pro
  //           accessibilityLabel="Double tap to edit payment method"
  //           aria-label="Double tap to edit payment method"
  //           name="chevron-right"
  //           color={Styles.lightGray}
  //           size={Styles.Fonts.f2}
  //           light
  //         />
  //       }
  //     </View>
  //   </View>
  // </AVTouchableOpacity>
  <AVTouchableOpacity
    accessible={true}
    accessibilityRole="button"
    accessibilityHint="Double tap to navigate to the screen of the chosen card to update info or delete"
    role="button"
    onPress={() => onCreditCardClick(creditCard)}
    accessibilityLabel="onCreditCardClick"
    aria-label="onCreditCardClick"
  >
    <View style={[getWalletStyles()['tileDesign']]}>
      <View style={[getWalletStyles()['creditCardInfo']]}>
        <View
          accessibilityLabel={`Issuer ${creditCard.cardIssuer}`}
          accessibilityRole="image"
          aria-label={`Issuer ${creditCard.cardIssuer}`}
          role="img"
          style={[
            getWalletStyles()['cardRoundedView'],
            getAmexExtraSVGPadding(creditCard.cardIssuer),
          ]}
        >
          <CreditCardImage
            issuer={creditCard.cardIssuer}
            style={getWidthAndHeightCombination(creditCard.cardIssuer)}
          />
        </View>
        <View style={{padding: Styles.Spacing.m2 + 4}}>
          <View style={getWalletStyles()['creditCardExpView']}>
            <AVText
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
              accessibilityLabel={strings.Labels.credit_card}
              accessibilityRole="text"
              aria-label={`${strings.Labels.credit_card}, text`}
              style={[getWalletStyles()['creditCardLabel']]}
            >
              {strings.Labels.credit_card}
            </AVText>
            {getCardExpiredLayout(creditCard)}
          </View>
          <AVText
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
            accessibilityLabel={creditCard.name}
            accessibilityRole="text"
            aria-label={`${creditCard.name}, text`}
            style={[getWalletStyles()['cardNumber']]}
          >
            {getCreditCardNumber(creditCard.name)}
          </AVText>
        </View>
      </View>
      {creditCard.isDefault && (
        <View style={[getWalletStyles()['starIconView'], {}]}>
          <View
            accessibilityLabel="Default payment method, "
            aria-label="Default payment method, "
            style={getWalletStyles()['starIcon']}
          >
            <Star
              fillColor={Styles.Colors.PayNew.primary01}
              width={24}
              height={24}
            />
          </View>
        </View>
      )}
      <View
        style={[
          getWalletStyles()['chevronView'],
          //creditCard.isDefault ? {left: 20} : {left: 40},
        ]}
      >
        {
          <FontAwesome5Pro
            accessibilityLabel="Double tap to edit payment method"
            aria-label="Double tap to edit payment method"
            name="chevron-right"
            color={Styles.footerTabInactive}
            size={Styles.Fonts.f2 + 3}
          />
        }
      </View>
    </View>
  </AVTouchableOpacity>
);

function renderPayroll(props, state, callback) {
  const footerComp: Array<JSX.Element> = [];
  if (state.showPayroll) {
    const chevron = (
      <FontAwesome5Pro
        accessibilityLabel="View payroll information"
        aria-label="View payroll information"
        name="chevron-right"
        color={Styles.footerTabInactive}
        size={Styles.Fonts.f2 + 3}
      />
    );
    let rightView;
    let additionalText;

    if (state.payrollPending) {
      additionalText = (
        <View
          style={[getWalletStyles()['pendingView'], {alignItems: 'center'}]}
        >
          <AVText
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
            accessibilityLabel={Localized.Labels.pending_upper_case}
            accessibilityRole="text"
            aria-label={`${Localized.Labels.pending_upper_case}, text`}
            style={[
              getWalletStyles()['cardNumber'],
              getWalletStyles()['pending'],
            ]}
          >
            {Localized.Labels.pending_upper_case}
          </AVText>
        </View>
      );
      rightView = <View style={{alignSelf: 'center'}}>{chevron}</View>;
    } else {
      additionalText = (
        <AVText
          accessibilityLabel={Localized.Labels.last_four_of_card}
          accessibilityRole="text"
          aria-label={`${Localized.Labels.last_four_of_card}, text`}
          style={[getWalletStyles()['cardNumber']]}
        >
          {getCreditCardNumber(props.payrollId)}
        </AVText>
      );
      rightView = (
        <View
          style={[getWalletStyles()['pendingView'], {alignItems: 'center'}]}
        >
          {<>{chevron}</>}
        </View>
      );
    }

    footerComp.push(
      <TouchableOpacity
        accessible={true}
        onPress={callback}
        style={[getWalletStyles()['tileDesign']]}
        accessibilityLabel="payrollDeductButton"
        aria-label="payrollDeductButton"
        role="button"
      >
        <View style={getWalletStyles()['creditCardInfo']}>
          <View
            style={getWalletStyles()['cardRoundedView']}
            accessibilityLabel="Payroll image"
            accessibilityRole="image"
            aria-label="Payroll image"
            role="img"
          >
            <CreditCardImage
              issuer={
                Settings.isRefiveAnd365Pay()
                  ? AccountConstants.PAYROLL_TOKEN_REDESIGN.toString()
                  : AccountConstants.PAYROLL_TOKEN.toString()
              }
              style={getWidthAndHeightCombination(
                Settings.isRefiveAnd365Pay()
                  ? AccountConstants.PAYROLL_TOKEN_REDESIGN.toString()
                  : AccountConstants.PAYROLL_TOKEN.toString(),
              )}
            />
          </View>
          <View style={{padding: Styles.Spacing.m2 + 4}}>
            <AVText
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
              accessibilityLabel={Localized.Labels.payroll_deduct}
              accessibilityRole="text"
              aria-label={`${Localized.Labels.payroll_deduct}, text`}
              style={[getWalletStyles()['label']]}
            >
              {Localized.Labels.payroll_deduct}
            </AVText>
            {additionalText}
          </View>
        </View>
        {rightView}
      </TouchableOpacity>,
    );
  }

  return <>{footerComp}</>;
}
export function getWalletStyles(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    container: {
      flex: 1,
    },
    chevronView: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    buttonsView: {
      flexDirection: 'row',
      alignItems: 'center',
      flexGrow: 0,
    },
    noCardsOrBalancesImage: {
      flex: 1,
      alignSelf: 'center',
      alignItems: 'center',
      justifyContent: 'center',
    },
    noCardsOrBalances: {
      fontSize: Styles.Fonts.f7,
      fontWeight: 'bold',
      fontFamily: getDescriber().walletForntStyleText(),
      color: Styles.tabBarTextColor,
      marginTop: Styles.Spacing.m3,
    },
    scrollContainer: {
      marginHorizontal: Styles.Spacing.m3,
      marginTop: Styles.Spacing.m3 + Styles.Spacing.m3 - 4,
    },
    buttonContainer: {
      height: 55,
      flex: 1,
      borderRadius: Styles.Spacing.m2,
      borderWidth: 1,
      borderColor: Styles.darkGreenRevolve,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    addButtonText: {
      marginLeft: Styles.Spacing.m2,
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontSize: Styles.Fonts.f8,
      fontWeight: '700',
      color: Styles.black,
      textAlignVertical: 'center',
    },
    btnStyle: {
      alignSelf: 'center',
    },
    safeAreaView: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },

    creditCardInfo: {
      alignItems: 'center',
      flexDirection: 'row',
    },
    issuerImage: {
      alignSelf: 'flex-start',
      marginRight: Styles.Spacing.m2,
    },

    label: {
      color: Styles.darkColor,
      fontSize: Styles.Fonts.f7,
      fontWeight: 'bold',
      fontFamily: getDescriber().walletForntStyleText(),
    },
    pending: {
      color: Styles.warningColor,
      marginRight: Styles.Spacing.m2,
    },
    pendingView: {
      flexDirection: 'row',
    },
    starIconView: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      flex: 1,
      marginRight: Styles.Spacing.m2 + 3,
    },
    starIcon: {
      bottom: 0,
    },
    subLabel: {
      color: Styles.lightGray,
      fontSize: Styles.Fonts.f0,
    },
    blurBackground: {
      position: 'absolute',
      top: Styles.Spacing.m0,
      bottom: Styles.Spacing.m0,
      left: Styles.Spacing.m0,
      right: Styles.Spacing.m0,
      backgroundColor: Styles.overlay,
    },
    modal: {
      flex: 1,
      borderRadius: Styles.Spacing.m2,
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalContainer: {
      width: Styles.ScreenWidth / 1.1,
      height:
        Platform.OS === 'ios'
          ? Styles.ScreenHeight / 3
          : Styles.ScreenHeight / 2,
      borderRadius: 10,
    },
    subModalContainer: {
      backgroundColor: Styles.addCardPopupColor,
      paddingHorizontal: Styles.Spacing.m2,
      paddingVertical: Styles.Spacing.m3,
      borderRadius: Styles.Spacing.m2,
    },
    titleContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    cancelText: {
      color: Styles.primaryColor,
    },
    boldText: {
      fontWeight: 'bold',
      color: Styles.darkColor,
    },
    cardForm: {
      height: Styles.ScreenHeight / 2,
      marginTop: Styles.Spacing.m3,
    },
    cardStyle: {
      backgroundColor: Styles.addCardPopupColor,
    },
    cardNumber: {
      color: Styles.lightGray,
      fontSize: Styles.Fonts.f1,
    },
    addView: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginBottom: Styles.Spacing.m3 + 8,
      marginLeft: Styles.Spacing.m2,
    },
    addViewWrapper: {
      flexDirection: 'column',
      justifyContent: 'flex-end',
      marginBottom: Styles.Spacing.m3,
    },
    addBtn: {
      marginRight: Styles.Spacing.m2 + 2,
      //paddingVertical: Styles.Spacing.m1,
      marginBottom: Styles.Spacing.m4 - 8,
    },
    nocardsContainer: {
      width: 300,
      height: 450,
      marginVertical: 'auto',
      padding: 120,
      top: -40,
    },
    addBtnIcon: {
      marginLeft: 8,
    },
    circle: {
      width: 50,
      height: 50,
      borderRadius: 100 / 2,
      backgroundColor: Styles.primaryColor,
    },
    creditCard: {
      alignItems: 'center',
      backgroundColor: Styles.white,
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: Styles.Spacing.m3,
      paddingLeft: Styles.Spacing.m2,
      borderBottomColor: Styles.lightGray,
    },
    tileDesign: {
      width: '100%',
      height: 82,
      padding: Styles.Spacing.m3,
      flexDirection: 'row',
      backgroundColor: Styles.white,
      borderRadius: Styles.Spacing.m2,
      marginBottom: Styles.Spacing.m2 + Styles.Spacing.m1,
      justifyContent: 'space-between',
      display: 'flex',
      paddingHorizontal: 15,
      paddingVertical: 10,
      borderWidth: 1.5,
      borderColor: Styles.neutralHues,
    },
    revolveAddTxt: {fontWeight: '400', fontSize: 18, color: Styles.black},
    revolveMainTxt: {fontWeight: '700', fontSize: 18, color: Styles.black},
    revolvePendingRightView: {fontWeight: '400', fontSize: 16},
    cardRoundedView: {
      padding: Styles.Spacing.m2,
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 50,
      width: 50,
      height: 50,
      backgroundColor: getDescriber().cardsMainViewBgColor(),
    },
    creditCardLabel: {
      color: Styles.darkColor,
      fontSize: Styles.Fonts.f7,
      fontWeight: 'bold',
      marginRight: Styles.Spacing.m3,
    },
    creditCardExpView: {
      flexDirection: 'row',
    },
  };
}

export function getBalancesTitle(): JSX.Element {
  return null;
}

export function getBalancesList() {
  return null;
}

export function getCardsTitle(): JSX.Element {
  return null;
}

export function getWalletBottomSection(
  creditCards,
  showPayroll,
  callbacks,
): JSX.Element {
  return (
    <View
      style={[getWalletStyles()['buttonsView'], {justifyContent: 'flex-end'}]}
    >
      {getRoundedAppButton(
        Localized.Labels.add_egift_card_lower,
        'Double tap to add new egift card',
        callbacks[0],
      )}

      {getRoundedAppButton(
        capitalizeFirstWord(Localized.Labels.add_credit_card),
        'Double tap to add new credit card',
        callbacks[1],
        true,
      )}
    </View>
  );
}

function getRoundedButton(label, hint, onpress) {
  return (
    <RoundedButton
      accessible={true}
      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm0}
      accessibilityLabel={label}
      accessibilityHint={hint}
      accessibilityRole="button"
      aria-label={label}
      role="button"
      containerStyle={[
        getWalletStyles()['addBtn'],
        {borderRadius: Styles.Spacing.m4},
      ]}
      buttonType={ButtonType.outline}
      text={label}
      textStyle={null}
      onPress={onpress}
    />
  );
}

export function getWalletBalanceSection(): JSX.Element {
  return null;
}

export default {
  getBalancesList,
  getBalancesTitle,
  getCardsTitle,
  getWalletStyles,
  getWalletTopButtonsSection,
  getWalletBottomSection,
  getWalletBalanceSection,
  getWalletCreditCardsSection,
};
